export default __webpack_public_path__ + "static/media/candidates-white.d0765f74.svg";